import { TableColumn } from '@maersk-global/mds-components-core/mc-table/types';

function gradeColumn(id: string): TableColumn {
  return { id, label: id.toUpperCase(), sortDisabled: true, width: '120px' };
}

export const ContainerGradeRepairCodeListGridColumns: Array<TableColumn> = [
  {
    id: 'repairCode',
    label: 'Repair Code',
    width: '120px',
    dataType: {
      type: 'string',
      formatter: (value) => {
        const stringValue = value as string;
        return stringValue || '';
      },
    },
  },
  { id: 'description', label: 'Description', sortDisabled: true, width: '450px' },
  { id: 'generateGradeChange', label: 'Generate grade change', sortDisabled: true, width: '180px' },
  { id: 'mode', label: 'Mode', sortDisabled: true, width: '70px' },
  gradeColumn('e'),
  gradeColumn('k'),
  gradeColumn('m'),
  gradeColumn('q'),
  gradeColumn('s'),
  { id: 'actions', label: '', sortDisabled: true, width: '80px' },
];
